<template>
  <div class="push-card-box" :class="{ portrait: isPortraitLive }">
    <template v-if="cardInfo.show_mode == 1">
      <div v-show="dialogVisible">
        <PushCardPreviewWap
          :style="{ zIndex: zIndexServerState.zIndexMap.pushCard }"
          @close="close"
          :isCms="isCms"
          :isEmbed="isEmbed"
          :isWechatBrowser="isWechatBrowser"
          :lang="lang"
          mode="wap-bubble"
          ref="preview"
        />
      </div>
    </template>
    <template v-else>
      <van-overlay :show="dialogVisible" :style="{ zIndex: zIndexServerState.zIndexMap.pushCard }">
        <div class="preivew-card">
          <PushCardPreviewWap
            :style="{ zIndex: zIndexServerState.zIndexMap.pushCard }"
            @close="close"
            :isCms="isCms"
            :isEmbed="isEmbed"
            :isWechatBrowser="isWechatBrowser"
            :lang="lang"
            mode="wap"
            ref="preview"
          />
        </div>
      </van-overlay>
    </template>
    <van-popup class="card-empty" z-index="3000" v-model="show" round closeable @close="close">
      <div class="fail-img">
        <img src="./img/fail-wap.png" alt="" />
      </div>
      <p>{{ $t('card.card_1002') }}</p>
    </van-popup>
  </div>
</template>
<script>
  import { PushCardPreviewWap, commonApi } from '@vhcl/push-card';
  import { isWechat } from '@/app-shared/utils/tool';
  import { useRoomBaseServer, useZIndexServer, useMsgServer } from 'middle-domain';
  export default {
    name: 'VmpCardPreviewWap',
    components: {
      PushCardPreviewWap
    },
    provide() {
      return {
        getWatchInitData: () => this.roomBaseServer.state.watchInitData,
        env: this.env
      };
    },
    data() {
      const { watchInitData = {}, languages } = this.roomBaseServer.state;
      const { webinar = {} } = watchInitData;
      const zIndexServerState = this.zIndexServer.state;
      return {
        zIndexServerState,
        dialogVisible: false,
        env: process.env.VUE_APP_ENV,
        webinarId: webinar.id,
        showModal: false,
        cardId: '',
        cardInfo: {},
        show: false,
        lang: languages.lang.type,
        isWechatBrowser: isWechat()
      };
    },
    computed: {
      // 是否为嵌入页
      isEmbed() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed;
      },
      // 是否是cms嵌入
      isCms() {
        return this.$domainStore.state.roomBaseServer.isCms == 1;
      },
      // 竖屏直播
      isPortraitLive() {
        return this.$domainStore.state.roomBaseServer?.webinarShowType == 0;
      }
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.zIndexServer = useZIndexServer();
      const { PushCard } = commonApi;
      this.cardServer = new PushCard();
    },
    created() {
      useMsgServer().$onMsg('ROOM_MSG', msg => {
        if (msg.data.type == 'live_over') {
          // 结束直播
          this.close();
        }
      });
      this.initEvents();
    },
    beforeDestroy() {
      this.$emitter.off(this.$EMIT_DEFINE.push_card_cancel, this.close);
    },
    methods: {
      initEvents() {
        this.$emitter.on(this.$EMIT_DEFINE.push_card_cancel, this.close);
      },
      close() {
        this.dialogVisible = false;
        this.show = false;
      },
      async open(cardInfo) {
        try {
          const cardId = cardInfo.id;
          const res = await this.cardServer.getPushCard({
            webinar_id: this.webinarId,
            id: cardId
          });
          if (res?.code === 200 && res?.data?.push_status != 3) {
            this.cardInfo = res.data;
            this.dialogVisible = true;
            this.show = false;
            this.$nextTick(() => {
              this.$refs.preview.open(this.cardInfo);
            });

            const { switch: switchInfo } = this.roomBaseServer.state.watchInitData;
            let cardIds = sessionStorage.getItem(switchInfo.switch_id);
            if (!cardIds) {
              cardIds = cardId;
            } else {
              if (!cardIds.includes(cardId)) {
                cardIds = `${cardIds},${cardId}`;
              }
            }
            // 查看卡片时将查看的id缓存
            sessionStorage.setItem(switchInfo.switch_id, cardIds);
            this.zIndexServer.setDialogZIndex('pushCard');
          } else if (res.code === 513600 || res.data?.push_status === 3) {
            // 空数据展示卡片删除弹窗
            this.$refs.preview.handleClose();
            this.dialogVisible = true;
            this.show = true;
            this.zIndexServer.setDialogZIndex('pushCard');
          } else {
            this.show = false;
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.show = false;
          console.log(error);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .card-empty {
    width: 640px;
    height: 431px;
    background: linear-gradient(54.82deg, #fdf1ed 12.42%, #f3f2ff 104.09%);
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    .fail-img {
      margin: 92px auto 0;
      width: 170px;
    }
    img {
      width: 100%;
    }
    p {
      text-align: center;
      font-weight: 600;
      font-size: 32px;
      line-height: 14px;
      color: #262626;
      word-break: break-word;
    }
    .close {
      width: 320px;
      height: 88px;
      margin: 52px auto 0;
      display: block;
    }
  }
  .preivew-card {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
  }
  .portrait {
    .wap-bubble {
      position: fixed;
      bottom: 160px;
      right: 25px;
    }
  }
</style>
